const getOrientation = () => {
  let orientation = ''
  if (window.screen?.orientation?.type) {
    orientation = window.screen?.orientation?.type
  } else if (window.matchMedia('(orientation: portrait)')) {
    orientation = 'portrait'
  } else if (window.matchMedia('(orientation: landscape)')) {
    orientation = 'landscape'
  }

  if (orientation.match('portrait')) {
    return 'portrait'
  } else if (orientation.match('landscape')) {
    return 'landscape'
  }
  return orientation
}

export {getOrientation}
